import { mapCourse } from './dashboardMappers';

export function mapWishlistItem(item) {
  if (!item?.course) return null;

  const course = mapCourse(item.course);
  if (!course?.id) return null;

  return {
    wishlistId: item.id ?? item.wishlist_id ?? null,
    course: {
      ...course,
      isFavorite: true,
    },
  };
}

export function mapWishlistsResponse(response) {
  const list =
    response?.data?.wishlists ||
    response?.data?.items ||
    response?.wishlists ||
    [];

  return list.map(mapWishlistItem).filter(Boolean);
}
